import { endPoint } from '@/constant/end-point'
import useAPI from '@/hooks/use-api'
import { useQuery } from '@tanstack/react-query'

function useSignedUrl(currentLogo?: string | null) {
  const { getOne } = useAPI<{ signedUrl: string }>()

  const { data: signedUrlData, isLoading } = useQuery({
    queryKey: ['signedUrl', currentLogo],
    queryFn: () => getOne(endPoint.uploads.signedUrl, { imageUrl: currentLogo || '' }),
    enabled: !!currentLogo && currentLogo.includes('blob.core.windows.net'),
  })

  return { signedUrl: signedUrlData?.data?.signedUrl ?? null, isLoading }
}

export default useSignedUrl
